<h2 data-qa="dfParticipantsSelect-headline">Teilnehmer Datenabfrage ATS</h2>

<mat-expansion-panel (closed)="netzbetreiberPanelOpenState = false"
  (opened)="netzbetreiberPanelOpenState = true"
  [expanded]="netzbetreiberPanelOpenState" fxFlexFill>
  <mat-expansion-panel-header>
    <mat-panel-description>
      Teilnehmernehmende Netzbetreiber ({{assignedNetzbetreiber?.length}}) / Nicht zugewiesen ({{notAssignedNetzbetreiber?.length}})
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div fxFlex="50" fxLayout="column">
    <mat-nav-list>
      <h3 mat-subheader>Teilnehmer der Abfrage ({{assignedNetzbetreiber?.length}})</h3>
      @for (zn of assignedNetzbetreiber; track zn.id) {
        <div fxLayout="row">
          <mat-list-item (click)="removeNetzbetreiber(zn.id)" [disabled]="!isWestnetzAdmin">
            <tnb-netzbetreiber-display-card [netzbetreiber]="zn"
            fxFlex="90"></tnb-netzbetreiber-display-card>
            <div class="material-symbols-outlined" fxFlex="10">
              <mat-icon svgIcon="innogy_picto_arrow-right"></mat-icon>
            </div>
          </mat-list-item>
        </div>
      }
    </mat-nav-list>
  </div>

  <div fxFlex="50" fxLayout="column">
    <mat-nav-list>
      <h3 mat-subheader>Nicht zugewiesene Netzbetreiber ({{notAssignedNetzbetreiber?.length}})</h3>
      @for (nzn of notAssignedNetzbetreiber; track nzn.id) {
        <div fxLayout="row">
          <mat-list-item (click)="addNetzbetreiber(nzn.id)" [disabled]="!isWestnetzAdmin">
            <div class="material-symbols-outlined" fxFlex="10">
              <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
            </div>
            <tnb-netzbetreiber-display-card [netzbetreiber]="nzn"
            fxFlex="90"></tnb-netzbetreiber-display-card>
          </mat-list-item>
        </div>
      }
    </mat-nav-list>
  </div>
</mat-expansion-panel>


